"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var StyleTileV2_1 = __importDefault(require("DreamCoat/SavedStyle/StyleTileV2/StyleTileV2"));
var BlockStyleTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/BlockStyleTypes");
exports.default = (function (modal, $log, environment, brandStore) {
    return function (style) {
        if (environment !== "production") {
            $log.log("Reverting Style:", style);
        }
        if ((0, BlockStyleTypes_1.isSourceStyle)(style)) {
            throw new Error("Attempting to revert an Embed block style");
        }
        var header = (react_1.default.createElement("header", { className: "header" },
            react_1.default.createElement("div", { className: "center" },
                react_1.default.createElement(StyleTileV2_1.default, { style: style, size: "large", colors: brandStore.allColors })),
            react_1.default.createElement("h3", { className: "title" }, "Revert this style?"),
            react_1.default.createElement("div", null,
                react_1.default.createElement("p", { className: "explainer" }, "Unsaved style changes in this block will be lost."))));
        return modal.showDeleteModal({
            header: header,
            confirmLabel: "Revert Style",
        });
    };
});
